import {EventEmitter, Injectable, Output} from '@angular/core';
import * as moment from 'moment';
import {SharedService} from '../../../shared.service';
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class ChartOffsetCalculatorService {
  threshold = 1000;
  dataStreamOffsets = {
   /* dataStream: {
      offset: 0,
      lastUpdate: 0
    }*/
  };
  isCheckRunning = true;
  prevMaxOffset = 0;
  offsetChangedEvent: EventEmitter<any> = new EventEmitter();
  constructor() {
    this.checkAliveDataStreams();
  }
  // Check continuous flow of data
  checkAliveDataStreams() {
    if ( ! this.isCheckRunning) {
      return;
    }
    let now = new Date().getTime();
    for (let key of Object.keys(this.dataStreamOffsets)) {
      let value = this.dataStreamOffsets[key];
      if (value.lastUpdate < now - 5000) {
        delete(this.dataStreamOffsets[key]);
      }
    }
    // schedule recursive call
    setTimeout( () => { this.checkAliveDataStreams(); }, 1000 );
  }

  now() {
    return moment().toDate().getTime();
  }

  setOffset(offset, dataStream) {
    this.dataStreamOffsets[dataStream] = {offset: offset, lastUpdate: new Date().getTime()};
  }

  getOffset(dataStream) {
    return this.dataStreamOffsets[dataStream] ? this.dataStreamOffsets[dataStream].offset : 0;
  }

/*  function getMaxOffset(){
    var offsets = _.map(dataStreamOffsets, function(item){
      return item.offset;
    });
    return offsets.length > 0? _.max(offsets) : 0;
  }
  */
  getMaxOffset() {
    let offsets = [];
    for (let key of Object.keys(this.dataStreamOffsets)) {
      let value = this.dataStreamOffsets[key];
      offsets.push(value.offset);
    }

    /*let offsets = _.map(this.dataStreamOffsets, function(item) {
      return item.offset;
    });*/
    console.log('offsets = '+ offsets)
    // @ts-ignore
    //return offsets.length > 0 ? Math.max(offsets) : 0;
    if(offsets.length > 0){
      var max = offsets.reduce(function(a, b) {
        return Math.max(a, b);
      });

      console.log(max);
      return max;
      //return Math.max(offsets);
    }else{
      return  0;
    }
  }

  /*this.subscribe =function(scope, callback){
    var handler = $rootScope.$on('offset-changed-event', callback);
    scope.$on('$destroy', handler);
  }*/

  computeOffset(dataStream, timestamp){
    var dt = this.now() - timestamp;
    var offset = this.getOffset(dataStream);

    if(dt > 0 && Math.abs(offset - dt) > this.threshold) {
      this.setOffset(dt, dataStream);
    }

    var maxOffset = this.getMaxOffset();
    console.log('maxOffset = '+maxOffset);
    if (this.prevMaxOffset !== maxOffset){
      //$rootScope.$emit('offset-changed-event', maxOffset);
      // tslint:disable-next-line:no-unused-expression
      let maxOffsetEmit =  maxOffset;
      this.offsetChangedEvent.emit(maxOffsetEmit);
      this.prevMaxOffset = maxOffset;
    }
    return maxOffset;
  };

}
